import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import Align from '@marvelapp/marvel-ui/align';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import Heading from '@marvelapp/marvel-ui/heading';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Image from 'marketing-website/components/modules/Image';
import propTypeEmptyString from 'marketing-website/utils/customPropTypesCheck.js';

import heroStyles from '../style/general.module.css';
import illustrationStyles from './style/illustration.module.css';

const cx = classNames.bind({
  ...heroStyles,
  ...illustrationStyles,
});

export default function HeroIllustration({
  children,
  color,
  copy,
  headingMaxWidth,
  imageMaxWidth,
  isContactUsPage = false,
  src,
  title,
  tag,
}) {
  const heroClassName = cx('hero');
  const illustrationClassName = cx('illustration');

  return (
    <div className={heroClassName}>
      <PageWrap size="l">
        <Spacing type="padding" size="xl" position="topBottom">
          <Grid columns={12} alignItems="center">
            <GridItem columnSpan={12} columnSpanM={5}>
              <Align type="center" typeM="left">
                <Container
                  isContactUsPage={isContactUsPage}
                  headingMaxWidth={headingMaxWidth}
                >
                  <Heading tag={tag} size="xxxl" color={color} weight="bold">
                    {title}
                  </Heading>
                  {copy && (
                    <Spacing type="margin" size="xs" position="top">
                      <Paragraph size="l" color={color}>
                        {copy}
                      </Paragraph>
                    </Spacing>
                  )}
                  {children}
                </Container>
              </Align>
            </GridItem>
            <GridItem columnSpan={12} columnSpanM={7}>
              <div className={illustrationClassName}>
                {src && (
                  <Image
                    alt={title}
                    maxWidth={imageMaxWidth}
                    src={src}
                    hasShadow={false}
                    useImageTag
                  />
                )}
              </div>
            </GridItem>
          </Grid>
        </Spacing>
      </PageWrap>
    </div>
  );
}

const validColors = [
  'white',
  'black',
  'steel',
  'slate',
  'silver',
  'darkSmoke',
  'extraDarkSmoke',
  'smoke',
  'darkSnow',
  'extraDarkSnow',
  'snow',
];

const validTags = ['h1', 'h2'];

function Container({ isContactUsPage, children, headingMaxWidth }) {
  if (isContactUsPage)
    return (
      <div
        style={{
          paddingLeft: '15%',
          paddingRight: '15%',
        }}
      >
        {children}
      </div>
    );
  return (
    <MaxWidth value={headingMaxWidth} display="inlineBlock">
      {children}
    </MaxWidth>
  );
}

Container.propTypes = {
  isContactUsPage: PropTypes.bool,
  children: PropTypes.node,
  headingMaxWidth: PropTypes.number,
};

HeroIllustration.propTypes = {
  children: PropTypes.node,
  copy: PropTypes.string,
  headingMaxWidth: PropTypes.number,
  imageMaxWidth: PropTypes.number,
  isContactUsPage: PropTypes.bool,
  src: PropTypes.string,
  title: propTypeEmptyString,
  color: PropTypes.oneOf(validColors),
  tag: PropTypes.oneOf(validTags),
};

HeroIllustration.defaultProps = {
  imageMaxWidth: 660,
  headingMaxWidth: 460,
  color: 'black',
  tag: 'h1',
};



// WEBPACK FOOTER //
// ./src/components/modules/Hero/HeroIllustration/index.js